// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__9x3U_","spin":"loader_spin__qUIk7"};